import clsx from 'clsx';
import React from 'react';

type StatusBadgeProps = {
  status: 'open' | 'closed' | 'draft' | 'active' | 'void' | 'failed';
  className?: string;
};

const statusColors = {
  open: 'text-forest',
  active: 'text-forest',
  closed: 'text-main-500',
  draft: 'text-amber',
  void: 'text-main-500',
  failed: 'text-amber',
};

export const StatusBadge = ({
  status,
  className,
}: StatusBadgeProps): JSX.Element => (
  <div
    className={clsx(
      'border-main-300',
      'flex items-center justify-center',
      'px-f2 py-0',
      className
    )}
  >
    {status}
  </div>
);
